// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { ProcurementSubscriptions } from '../../../../types/server/modules/procurement/subscriptions';

export type * from '../../../../types/server/modules/procurement/subscriptions';

export const createSubscriptions = ( requests: Requests ): ProcurementSubscriptions => ({
  ProcurementSuppliers: ( params, onChange ) => {
          return requests.subscribe( `/procurement/suppliers/:supplierId?`, params, 'ProcurementSuppliers', onChange );
          },
  ProcurementPurchaseOrders: ( params, onChange ) => {
          return requests.subscribe( `/procurement/purchase-orders/:purchaseOrderId?`, params, 'ProcurementPurchaseOrders', onChange );
          },
  ProcurementItemSourcing: ( params, onChange ) => {
          return requests.subscribe( `/procurement/item-sourcing/:itemId?`, params, 'ProcurementItemSourcing', onChange );
          }
});
